/**
 * Minimal cookie helpers. Unlike localStorage, a cookie can be scoped
 * with a Domain attribute so it survives a full-page cross-subdomain
 * navigation — used for client-side state (like the active role) that
 * needs to be readable on both dev.irancharsouq.ir and its vendor
 * subdomains.
 */

export function getCookie(name) {
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
  const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name, value, { domain, days = 30 } = {}) {
  const maxAge = days * 24 * 60 * 60;
  let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
  if (domain) cookie += `; domain=${domain}`;
  document.cookie = cookie;
}

export function deleteCookie(name, { domain } = {}) {
  let cookie = `${name}=; path=/; max-age=0; samesite=lax`;
  if (domain) cookie += `; domain=${domain}`;
  document.cookie = cookie;
}